export default{
    en:{
        tab:{
            notice:'Notice',
        },
        list:{
            notice:{
                title:'Title',
                useYn:'Noticed',
                contents:'Content',
                firstRegDt:'Date',
            },
        },
        detail:{
            title:'Title',
            contents:'Content',
            files:'Files',
            useYn:'Noticed',
            useY:'Noticed',
            useN:'Not Noticed',
        }
    },
    ko:{
        tab:{
            notice:'공지사항',
        },
        list:{
            notice:{
                title:'제목',
                contents:'내용',
                useYn:'공지여부',
                firstRegDt:'등록일자',
            },
        },
        detail:{
            title:'제목',
            contents:'내용',
            files:'첨부파일',
            useYn:'공지여부',
            useY:'공지함',
            useN:'공지안함',
        }
    },
}